import { createSlice } from "@reduxjs/toolkit";

export const loadingBarSlice = createSlice({
  name: "loadingBarSlice",
  initialState: {
    progress: 0,
  },
  reducers: {
    setLoadingBarProgress: (state, payload) => {
      // console.log(payload.payload.progress);
      state.progress = payload.payload.progress;
    },
  },
});

export const { setLoadingBarProgress } = loadingBarSlice.actions;

export default loadingBarSlice.reducer;
